<template>
  <div class="cs-content-white">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "BlankLayout",
};
</script>

<style lang="scss" scoped>
.cs-content-white {
  background-color: white;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/layout/BlankLayout.vue